import { gridWithOneActionBlock, gridWithTwoActionBlocks, ACTION_BLOCK_GROUPS, MAX_TOP_CATEGORIES, } from './constants';
const getActionBlocksByKeyList = (keys, actionBlocks) => {
  return keys.map((key) => actionBlocks[key]).filter(Boolean);
};
export const getActionBlockCellsCount = (actionBlocks, isAltSecondary = false) => {
  const keys = Object.keys(actionBlocks !== null && actionBlocks !== void 0 ? actionBlocks : {});
  if (!keys.length) {
    return 0;
  }
  const group = isAltSecondary ? ACTION_BLOCK_GROUPS.ALT_SECONDARY : ACTION_BLOCK_GROUPS.SECONDARY;
  return keys.some((key) => group.includes(key)) ? 2 : 1;
};
export const getTopCategoriesMaxCount = (actionBlocks) => {
  return MAX_TOP_CATEGORIES - getActionBlockCellsCount(actionBlocks);
};
export const getLeftCellIndex = (categoriesTotalCount, actionBlocks, isAltGroups = false) => {
  const actionBlockCellsCount = getActionBlockCellsCount(actionBlocks, isAltGroups);
  const categoriesMaxCount = getTopCategoriesMaxCount(actionBlocks);
  const categoriesCount = Math.min(categoriesTotalCount, categoriesMaxCount);
  const totalCount = categoriesCount + actionBlockCellsCount;
  if (actionBlockCellsCount === 1) {
    return totalCount < 11 ? totalCount - 3 : totalCount - 4;
  }
  if (actionBlockCellsCount === 2) {
    return totalCount === 9 || totalCount === 10 ? totalCount - 3 : totalCount - 4;
  }
};
export const getGridItemsComposition = (categories, actionBlocks, isAltGroups = false) => {
  if (!actionBlocks || !Object.keys(actionBlocks).length) {
    return categories.slice(0, MAX_TOP_CATEGORIES);
  }
  const topCategoriesMaxCount = getTopCategoriesMaxCount(actionBlocks);
  const itemsComposition = categories.slice(0, topCategoriesMaxCount);
  const leftCellIndex = getLeftCellIndex(categories.length, actionBlocks, isAltGroups);
  const primaryGroup = getActionBlocksByKeyList(isAltGroups ? ACTION_BLOCK_GROUPS.ALT_PRIMARY : ACTION_BLOCK_GROUPS.PRIMARY, actionBlocks);
  const secondaryGroup = isAltGroups
    ? getActionBlocksByKeyList(ACTION_BLOCK_GROUPS.ALT_SECONDARY, actionBlocks)
    : getActionBlocksByKeyList(ACTION_BLOCK_GROUPS.SECONDARY, actionBlocks);
  itemsComposition.splice(leftCellIndex, 0, primaryGroup);
  if (secondaryGroup.length) {
    itemsComposition.push(secondaryGroup);
  }
  return itemsComposition;
};
export const isTopCategoryCardLarge = (topCategoriesCount, actionBlocks, itemIndex, isAltSecondary = false) => {
  var _a;
  const actionBlockCellsCount = getActionBlockCellsCount(actionBlocks, isAltSecondary);
  const totalCount = topCategoriesCount + actionBlockCellsCount;
  const grid = actionBlockCellsCount === 2 ? gridWithTwoActionBlocks : gridWithOneActionBlock;
  return (_a = grid[totalCount]) === null || _a === void 0 ? void 0 : _a.includes(itemIndex);
};
